(ns web3.components.upload
  (:require [applied-science.js-interop :as j]
            [cljs.core.async :refer (chan put! close! <! >! timeout)]
            [cljs-http.client :as http]
            [reagent.core :as r]
            [goog.object :as gobj]
            [web3.i18n :as i]
            [web3.utils :as utils]
            [web3.queries.asset :as q-asset]
            [clojure.string :as str]
            [re-frame.core :as rf]
            [web3.view :as v]
            [web3.components.progress :as progress]
            [web3.components.text :as text]
            [clojure.string :as string]
            [web3.ui-state :as ui-state]
            [web3.components.branch :as branch]
            [web3.components.widgets :as widgets]
            [web3.modals.forms :as forms]
            [web3.lazy :as lazy]
            [kitchen-async.promise :as p]
            [web3.icons.shapes :as shapes]
            [web3.view.hiccup :as hiccup])
  (:require-macros [cljs.core.async.macros :refer [go]]))

(def mobile-phone-icon
  [:svg
   {:y "0px",
    :preserve-aspect-ratio "xMidYMid meet",
    :xml-space "preserve",
    :width "486px",
    :view-box "0 0 486 792",
    :x "0px",
    :enable-background "new 0 0 486 792",
    :height "792px"}
   [:g
    {:fill "currentColor"}
    [:path
     {:d "M375.247-0.759H110.753c-60.75,0-110.212,49.462-110.212,110.212v573.094c0,60.75,49.462,110.212,110.212,110.212h264.493 c60.75,0,110.212-49.462,110.212-110.212V109.453C485.459,48.663,435.997-0.759,375.247-0.759z M441.389,682.508 c0,36.466-29.677,66.143-66.143,66.143H110.753c-36.466,0-66.143-29.677-66.143-66.143V109.453 c0-36.466,29.677-66.143,66.143-66.143h264.493c36.466,0,66.143,29.677,66.143,66.143L441.389,682.508L441.389,682.508z"}]
    [:circle {:cx "243", :cy "682.508", :r "44.069"}]
    [:path
     {:d "M287.069,65.345h-88.177c-12.181,0-22.035,9.854-22.035,22.035s9.854,22.035,22.035,22.035h88.177 c12.181,0,22.035-9.854,22.035-22.035S299.25,65.345,287.069,65.345z"}]]])

(defonce ^:private *dropify (atom nil))
(defonce ^:private *jquery (atom nil))

(defonce uploaded-image-blobs
         (atom {}))

(def ^:private dropify-opts
  (j/lit {:messages {:default (i/get (if (ui-state/mobile?)
                                       :files.upload.messages/mobile
                                       :files.upload.messages/default))
                     :replace (i/get :files.upload.messages/replace)
                     :remove (i/get :files.upload.messages/remove)
                     :error (i/get :files.upload.messages/error)}
          :error {:fileSize (i/get :files.upload.error/file-size)
                  :minWidth (i/get :files.upload.error/min-width)
                  :maxWidth (i/get :files.upload.error/max-width)
                  :minHeight (i/get :files.upload.error/min-height)
                  :maxHeight (i/get :files.upload.error/max-height)
                  :imageFormat (i/get :files.upload.error/image-format)}}))

(defn- dropify-element!
  [{:keys [element default-value event-handlers]}]
  (let [element
        (-> (@*jquery element)
            (j/call :dropify (cond-> dropify-opts
                                     default-value
                                     (j/assoc! :defaultFile default-value))))]
    (doseq [[event handler] event-handlers]
      (.on ^js element event handler))
    element))

(defn- gen-form-data
  [this file]
  (let [out (chan)]
    (q-asset/generate-form-data-upload!
      {:mediaType (.-type file)}
      {:component this
       :on-complete
       (fn [data]
         (put! out (-> data
                       utils/->clj-map
                       (get-in [:data :generate-form-data-upload]))))})
    out))

(defn- upload-file!
  [this file]
  (go
    (let [{:keys [form-data
                  form-data-file-uri-path
                  headers
                  method
                  url]
           :as data} (<! (gen-form-data this file))
          headers (-> headers
                      js/JSON.parse
                      js->clj)
          form-data (-> form-data
                        js/JSON.parse
                        js->clj)
          fd (js/FormData.)]
      (doseq [[k v] form-data]
        (case k
          "file" (.append fd (name k) file (.-name file))
          (.append fd k (clj->js v))))

      (let [{:keys [status success body error-text]
             :as resp}
            (<! (http/request {:method (-> method str/lower-case keyword)
                               :url url
                               :headers headers
                               :with-credentials? false
                               :body fd}))]
        (if success
          {:value url}
          {:error (ex-info error-text resp)})))))

(defn- get-file
  [input]
  (some-> (.-files input)
          (gobj/get 0)))

(defn- parse-filename [filename]
  (let [[_ filename ext] (re-find #"(.*)\.([^\.]*)$" filename)]
    {:filename filename
     :ext ext}))

(comment
  (assert (= {:filename "ab"
              :ext "c"} (parse-filename "ab.c")))
  (assert (= {:filename "ab.c"
              :ext "d"} (parse-filename "ab.c.d"))))

(def ^:private dark-button-props
  {:style {:background-color "rgba(255,255,255,0.1)"
           :padding-left "1rem"
           :padding-right "1rem"}
   :class "hover-text-underline text-white ph3"})

(v/defview ^:private use-mobile-hint
  [{:keys [as-hint? left-text]}]
  (let [{:keys [state] :as this} (r/current-component)
        {:keys [status phone loading? error message]} @state
        send! #(do (swap! state assoc :loading? true)
                   (branch/send-sms! phone
                                     (fn [error]
                                       (swap! state merge (cond-> {:loading? false}
                                                                  error (assoc :error
                                                                               (branch/parse-branch-error error))
                                                                  (nil? error) (assoc :message (i/to-do "Success!")
                                                                                      :status :complete
                                                                                      :error nil))))))]
    [:div.bg-black.text-white.pad-h-3.text-size-13.flex.items-start.items-center.pad-v-2_5.round-4.margin-bottom-1.relative.z-2
     [:div.flex.items-center
      {:class (if (= status :expanded)
                "width-100p"
                "margin-h-auto")}
      (when as-hint?
        (-> shapes/triangle
            (hiccup/size 16)
            (hiccup/class "text-black")
            (hiccup/styles {:position "absolute"
                            :left "50%"
                            :margin-left -8
                            :bottom -12
                            :transform-origin "center center"
                            :transform "scaleY(-1)"})))
      (-> mobile-phone-icon
          (hiccup/size 30)
          (hiccup/styles {:margin-right 10}))
      (case status
        :expanded
        [:div.width-100p.relative
         [:div.absolute.top-0.right-0.cursor-pointer.z-1
          {:on-click #(swap! state dissoc :status)}
          shapes/close-x]
         [text/input {:label (i/to-do "Phone Number")
                      :style {:color "white"}
                      :loading? loading?
                      :helptext [:div.text-white (or error message)]
                      :helptext-persistent? true
                      :on-key-down #(when (utils/save-event? %)
                                      (utils/stop-prevent! %)
                                      (send!))
                      :value phone
                      :on-change #(swap! state assoc :phone (.. % -target -value))}]
         [widgets/primary-button (-> dark-button-props
                                     (assoc :on-click send!)) "Send SMS"]]

        :complete
        [:div (i/to-do (str "Your link has been sent to " phone ". "))
         [:a.cursor-pointer.text-underline.block {:on-click #(swap! state assoc :status :expanded)}
          (i/to-do "Try Again")]]

        [:div.flex.items-center
         (when left-text
           [:div.ph2.flex-auto left-text])
         [widgets/primary-button (-> dark-button-props
                                     (assoc :on-click #(do (swap! state assoc :status :expanded)
                                                           (utils/focus-first-input! this)))) (i/get :i/text-me)]
         #_[:span.weight-bold.text-xblack (i/to-do "Pro tip: ")]
         #_(i/to-do "Take pictures using ")
         #_[:a.text-white {:href "https://app.mycentriq.com/"} "app.mycentriq.com"]
         #_(i/to-do " on your mobile device. ")
         #_[:a.text-white.text-underline.cursor-pointer
            {:on-click #(do (swap! state assoc :status :expanded)
                            (utils/focus-first-input! this))} (i/to-do "text me the link")]])]]))


(defn init-dropify [{{:keys [on-select
                             on-error
                             on-clear
                             value]} :props
                     state :state
                     :as this}]
  (assert @*dropify "file requires dropify passed in")
  (let [dropify-element (dropify-element!
                          {:element (-> (r/dom-node this)
                                        (j/call :getElementsByClassName "dropify")
                                        (aget 0))
                           :default-value (@uploaded-image-blobs value "")
                           :events-handlers
                           {"dropify.afterClear"
                            (fn [_ _]
                              (when on-clear
                                (on-clear))
                              (when on-select
                                (on-select {:filename nil})))
                            "dropify.errors"
                            (fn [_ el]
                              (when on-error
                                (on-error (parse-filename (.-name (get-file (.-element el)))))))}})]
    (swap! state assoc :dropify-element dropify-element)))

(v/defview file*
  {:component-did-mount
   (fn [{{:keys [deps-loading?]} :props
         :as this}]
     (when-not deps-loading?
       (init-dropify this)))}
  [{:keys [on-upload
           on-select
           auto-upload?
           label
           mobile-hint?

           helptext
           helptext-persistent?
           invalid?
           deps-loading?]
    loading?-prop :loading?
    :or {auto-upload? true
         mobile-hint? true}
    :as props}]
  (let [{:keys [state] :as this} (r/current-component)
        {:keys [loading?]} @state
        loading? (or loading? loading?-prop deps-loading?)
        mobile? (ui-state/mobile?)]
    [:div.relative.margin-bottom-2
     {:class (when invalid? "dropify--invalid")}
     (when label
       [:div.text-size-13.weight-semi-bold.text-dark-gray.margin-v-2 label])
     (when (and (not mobile?)
                mobile-hint?)
       [use-mobile-hint {:as-hint? true
                         :left-text (i/to-do "Want to use your phone's camera?")}])
     [progress/indeterminate {:height 4
                              :bg-color "white"
                              :style {:opacity (if loading? 1 0)
                                      :top "auto"
                                      :z-index 10
                                      :left 2
                                      :right 2
                                      :width "auto"
                                      :margin-top 2
                                      :position "absolute"}}]
     (if deps-loading?
       [:div.dropify-wrapper]
       [:input.dropify
        (v/merge-props
          {:type "file"
           :class (when loading? "opacity-50")
           :on-change
           (fn [e]
             (when-let [file (get-file (.-target e))]
               (let [error? (not= 0 (some-> (:dropify-element @state)
                                            ^js (@*jquery)
                                            (.data "dropify")
                                            (j/get-in [:errorsEvent :errors :length])))]
                 (when-not error?
                   (let [{:as result} {:file file
                                       :filename (.-name file)}]
                     (when on-select
                       (on-select result))
                     (when auto-upload?
                       (swap! state assoc :loading? true)
                       (forms/set-or-inc-loading!)

                       (go
                         (let [{location :value
                                error :error} (<! (upload-file! this file))]
                           (swap! state dissoc :loading?)
                           (forms/dec-loading!)
                           (cond location
                                 (do
                                   ;; store blob for this :link
                                   (swap! uploaded-image-blobs assoc location
                                          (js/URL.createObjectURL file))
                                   (on-upload (assoc result
                                                :location location)))
                                 error
                                 (rf/dispatch [:events/handle-error
                                               {:source :s3.upload/error
                                                :error error}]))))))))))}
          (dissoc props
                  :deps-loading?
                  :default-value
                  :on-upload
                  :on-select
                  :on-clear
                  :mobile-hint?
                  :auto-upload?
                  :value
                  :helptext
                  :helptext-persistent?
                  :invalid?
                  :dirty?))])
     [text/render-helptext {:text helptext
                            :persistent? helptext-persistent?}]]))

(defn- patch-dropify! [dropify]
  ;; patch dropify to recognize blobs as images
  (j/update-in! dropify
                [:prototype :isImage]
                (fn [is-image]
                  (fn []
                    (this-as this
                      (let [default (j/get-in this [:settings :defaultFile])]
                        (or (and default
                                 (string/ends-with? default (j/get-in this [:file :name]))
                                 (string/starts-with? default "blob:"))
                            (.call is-image this))))))))

(def load-lazy-deps
  ;; returns a promise which resolves when dropify/jquery
  ;; have been loaded. using `delay` instead of a function
  ;; because we always want to return the same promise, and
  ;; `delay` is cleaner than memoizing an anonymous function.
  (delay
    (p/let [dropify (lazy/load (lazy/loadable web3.components.dropify/dropify))
            jquery (lazy/load (lazy/loadable web3.components.dropify/jquery))]
      ; (p/timeout 2000) ;; for testing the loading view
      (patch-dropify! dropify)
      (reset! *dropify dropify)
      (reset! *jquery jquery))))

(defn file [& args]
  [lazy/promise-view
   (p/do @load-lazy-deps
         ;; wait for deps to load,
         ;; then render `file*` normally
         (into [file*] args))
   {:loading-view
    ;; while loading, render `file*` with `:deps-loading? true`
    (let [file (v/partial-props file* {:deps-loading? true})]
      (into [file] args))}])
